import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getQRCode } from '../actions';
import { Font } from '../common/Styles';

export const QrCode = () => {
  const dispatch = useDispatch();
  const qrCode = useSelector(state => state.qrCode);
  const appStoreURL = useSelector(state => state.ios);
  const playStoreURL = useSelector(state => state.android);

  const hasRedirected = useRef(false);

  const handleRedirect = () => {
    if (hasRedirected.current || !appStoreURL || !playStoreURL) return;
    hasRedirected.current = true;

    const userAgent = navigator.userAgent || '';
    const isAndroid = /android/i.test(userAgent);
    const isIOS = /iPhone|iPad|iPod/i.test(userAgent);

    const universalLinkURL = window.location.href;

    if (isIOS || isAndroid) {
      console.log('Attempting universal link via iframe...');
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = universalLinkURL;
      document.body.appendChild(iframe);

      setTimeout(() => {
        const fallbackURL = isIOS ? appStoreURL : playStoreURL;
        console.log('Redirecting to fallback store:', fallbackURL);
        window.location.href = fallbackURL;
      }, 2000); 
    }
  };

  useEffect(() => {
    dispatch(getQRCode());
  }, [dispatch]);

  useEffect(() => {
    if (appStoreURL && playStoreURL && !hasRedirected.current) {
      handleRedirect();
    }
  }, [appStoreURL, playStoreURL]);

  return (
    <div style={styles.container}>
      <p style={styles.text}>
        <strong>Hold your smartphone camera over the QR code to get the app</strong>
      </p>
      <img src={`data:image/png;base64,${qrCode}`} alt="QR code" width="300" height="300" />
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    ...Font,
    wordBreak: 'break-all',
  },
};
